import HomeSearch from './components/homeSearch';

function App() {
  return (
    <div className="App">
      <HomeSearch />
    </div>
  );
}

export default App;
